import React from 'react';
import { useThemes } from '@core/hooks';

// devExtreme
import ScrollView from 'devextreme-react/scroll-view';

interface SingleCardProps {
  title: string;
}

const SingleCard: React.FC<SingleCardProps> = ({ title, children }) => {
  const { isDark } = useThemes();

  return (
    <ScrollView height="100%" width="100%" className="with-footer single-card">
      <div className="dx-card content">
        <div className="header">
          <div className={isDark ? 'title title--light' : 'title'}>{title}</div>
        </div>
        {children}
      </div>
    </ScrollView>
  );
};

export default SingleCard;
